export { OpenidAuthorizationContainer } from '@/components/pages/Auth/Openid/Authorization';
